<template>
  <div class="inputBox">
    <div style="
        text-align: left;
        justify-content: flex-start;
        align-items: center;
      " class="flexBox">
      <div class="tool-item">
        <div class="icon-wrapper">
          <el-upload action=" " :before-upload="sendImg" :show-file-list="false" :disabled="!stateFlag">
            <i class="el-icon-picture-outline iconButton"></i>
          </el-upload>
        </div>
        <span class="tool-text">图片</span>
      </div>

      <div class="tool-item">
        <div class="icon-wrapper">
          <Camera :type="1" />
        </div>
        <span class="tool-text">拍照</span>
      </div>

      <div class="tool-item" @click="sendFlag">
        <div class="icon-wrapper">
          <img src="@/img/chufang.png" style="width: 35px;height: 35px;" class="imgIcon" />
        </div>
        <span class="tool-text">开处方</span>
      </div>

      <div class="tool-item" @click="handleMedicalRecord">
        <div class="icon-wrapper">
          <img src="@/img/dzbl.png" class="imgIcon" />
        </div>
        <span class="tool-text">写病历</span>
      </div>
      <div class="quick-reply-container">
        <el-autocomplete v-model="quickReplyInput" :fetch-suggestions="queryQuickReplies" placeholder="常用快捷语及问答"
          @select="handleQuickReplySelect" @focus="onQuickReplyFocus" style="width: 420px;margin-top: 15px;"
          ref="quickReplyAutocomplete" popper-class="quick-reply-dropdown">
          <template slot-scope="{ item }">
            <div class="suggestion-item">
              <span class="quick-reply-tag" :class="item.type === 2 ? 'qa-tag' : 'quick-tag'">
                <i :class="item.type === 2 ? 'el-icon-question' : 'el-icon-chat-dot-round'"></i>
                {{ item.type === 2 ? '问答' : '快捷语' }}
              </span>
              <span class="suggestion-title" :title="item.title">
                {{ item.title }}
              </span>
            </div>
          </template>
        </el-autocomplete>
      </div>
    </div>


    <div class="input-row" style="position: relative;">
      <el-input type="textarea" resize='none' v-model="input" @keyup.enter.native="handleEnterKey"
        @input="onMainInputChange" placeholder="请输入需要发送的信息！" ref="mainTextarea"
        :autosize="{ minRows: 8, maxRows: 12 }"></el-input>

      <div class="right-controls">
        <el-button v-if="!hasDialogVisible" @click="send()" class="sendButton" size="large" type="success">
          发送
        </el-button>
      </div>
    </div>

    <el-popover placement="bottom-start" width="400" trigger="manual" :append-to-body="false" :popper-options="{
      boundariesElement: 'body',
      gpuAcceleration: true,
      positionFixed: true,
      preventOverflow: true
    }" v-model="showQuickReplyPopover" popper-class="main-input-popover" ref="quickReplyPopover">
      <div class="quick-reply-list" ref="quickReplyListRef">
        <div v-for="(item, index) in matchedQuickReplies" :key="item.id" class="quick-reply-item"
          :class="{ 'selected': selectedQuickReplyIndex === index }" @click="handleQuickReplyClick(item, index)"
          @dblclick="handleQuickReplyDoubleClick(item)" @mouseleave="clearSelection">
          <span class="quick-reply-tag" :class="item.type === 2 ? 'qa-tag' : 'quick-tag'">
            <i :class="item.type === 2 ? 'el-icon-question' : 'el-icon-chat-dot-round'"></i>
            {{ item.type === 2 ? '问答' : '快捷语' }}
          </span>
          <span class="item-text" :title="item.title">
            {{ item.title }}
          </span>
        </div>
      </div>
    </el-popover>

    <el-dialog title="书写病历" :visible.sync="medicalVisible" width="1050px" append-to-body top="10vh">
      <div
        style="background: #f8f9fa; padding: 15px; border-radius: 4px; margin-bottom: 20px; display: grid; grid-template-columns: repeat(3, 1fr); gap: 15px; font-size: 14px; border: 1px solid #eef1f6;">
        <div><span style="color: #999;">患者姓名：</span>{{ medicalForm.userName }}</div>
        <div><span style="color: #999;">性别：</span>{{ medicalForm.userSex == 1 ? '男' : '女' }}</div>
        <div><span style="color: #999;">年龄：</span>{{ medicalForm.userAge }}岁</div>
        <div><span style="color: #999;">手机号：</span>{{ medicalForm.phone }}</div>
        <div><span style="color: #999;">身份证号：</span>{{ medicalForm.idNo }}</div>
        <div><span style="color: #999;">挂号单号：</span>{{
            medicalForm.registerNo }}</div>
      </div>

      <el-form :model="medicalForm" :rules="medicalRules" ref="medicalForm" label-width="80px"
        class="medical-form-content">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="主诉" prop="allergicHistory">
              <el-input type="textarea" v-model="medicalForm.allergicHistory" :rows="4" placeholder="请输入主诉"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="现病史" prop="presentIllness">
              <el-input type="textarea" v-model="medicalForm.presentIllness" :rows="4" placeholder="请输入现病史"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="诊断管理">
              <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                <el-button type="success" @click="addMedicalDiagnosis">新增诊断</el-button>
              </div>
              <el-table :data="medicalForm.prescriptionDiseInfoQOList" size="mini" style="width: 100%">
                <el-table-column label="诊断类别">
                  <template slot-scope="scope">
                    <el-select :disabled="true" v-model="scope.row.diagType" size="small"
                      @change="onMedicalDiagTypeChange(scope.row)">
                      <el-option label="西医诊断" value="1"></el-option>
                      <el-option label="中医诊断" value="2"></el-option>
                      <el-option label="中医病名" value="3"></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column label="主诊断标志">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.mainDiagFlag" size="small">
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column :label="isTraditionalChineseMedicine ? '中医病名' : '诊断名称'">
                  <template slot-scope="scope">
                    <InputLoadMore
                        v-if="scope.row.diagType === '3'"
                        v-model="scope.row.diagName"
                        :get-option-fn="getTcmDiagnosisOptions"
                        search-key="keyword"
                        placeholder="请选择中医病名"
                        @select="(item) => onMedicalDiagSelect(item, scope.row)"
                        @blur="onMedicalDiagBlur(scope.row)"
                        style="width: 100%" />

                    <InputLoadMore
                        v-else-if="scope.row.diagType === '1'"
                        v-model="scope.row.diagName"
                        :get-option-fn="getWesternDiagnosisOptions"
                        search-key="keyword"
                        placeholder="请选择西医诊断名称"
                        @select="(item) => onMedicalDiagSelect(item, scope.row)"
                        @blur="onMedicalDiagBlur(scope.row)"
                        style="width: 100%" />
                    <el-autocomplete
                        v-else
                        v-model="scope.row.diagName"
                        :fetch-suggestions="(q, cb) => searchMedicalDiagAutocomplete(q, cb, scope.row)"
                        placeholder="请选择诊断"
                        style="width: 100%"
                        @select="(item) => onMedicalDiagSelect(item, scope.row)"
                        @blur="onMedicalDiagBlur(scope.row)">
                      <template slot-scope="{ item }">
                        <div>{{ item.value }}</div>
                      </template>
                    </el-autocomplete>
                  </template>
                </el-table-column>

                <el-table-column v-if="isTraditionalChineseMedicine" label="中医证候">
                  <template slot-scope="scope">
                    <InputLoadMore
                        v-model="scope.row.sympName"
                        :get-option-fn="getTcmSyndromeOptions"
                        search-key="keyword"
                        placeholder="请选择中医证候"
                        @select="(item) => onMedicalSyndromeSelect(item, scope.row)"
                        @blur="onMedicalSyndromeBlur(scope.row)"
                        style="width: 100%" />
                  </template>
                </el-table-column>


                <el-table-column label="操作" width="100px">
                  <template slot-scope="scope">
                    <el-button type="danger" plain
                      @click="medicalForm.prescriptionDiseInfoQOList.splice(scope.$index, 1)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="既往史" prop="diseaseHistory">
              <el-input v-model="medicalForm.diseaseHistory" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="手术史" prop="operHistory">
              <el-input v-model="medicalForm.operHistory" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="过敏史" prop="allergyName">
              <el-input v-model="medicalForm.allergyName" placeholder="请输入过敏史"></el-input>
            </el-form-item>
          </el-col>
        </el-row>



        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="婚育史" prop="marryHistory">
              <el-input v-model="medicalForm.marryHistory" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="家族史" prop="familyHistory">
              <el-input v-model="medicalForm.familyHistory" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="肝功能" prop="liverFunction">
              <el-select v-model="medicalForm.liverFunction" style="width: 100%">
                <el-option v-for="item in medicalOptions" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="肾功能" prop="renalFunction">
              <el-select v-model="medicalForm.renalFunction" style="width: 100%">
                <el-option v-for="item in medicalOptions" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>



        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="诊疗意见" prop="treatmentSuggestion">
              <el-input type="textarea" v-model="medicalForm.treatmentSuggestion" :rows="3"
                placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>


      </el-form>

      <div slot="footer">
        <el-button type="success" @click="medicalVisible = false">取 消</el-button>
        <el-button type="success" @click="submitMedicalRecord" :loading="medicalLoading">保 存</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="tipsFlag" width="30%" :show-close="false" :close-on-click-modal="false" :modal="false"
      class="tipsMsgBox">
      <span style="font-size: 20px; font-weight: 800">{{ tipsMsg }}</span>
    </el-dialog>
  </div>
</template>
<script>
import store from "../../../../store/store";
import {
  msgUp, imgUpload, imgDownLoad, getQuickReplyTemplates, getMedicalRecordPre,
  saveMedicalRecord, dictDataList, sicknessList
} from "@/api/index";
import Camera from "@/components/tool/Camera.vue";
import InputLoadMore from "./InputLoadMore.vue";
export default {
  components: {
    Camera,
    InputLoadMore
  },
  props: {
    hasDialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      input: "",
      CF_Flag: false,
      tipsFlag: false,
      tipsMsg: "",
      storeImgData: {},
      quickReplyInput: "",
      quickReplyOptions: [],
      quickReplyLoading: false,
      quickReplySearchKeyword: "",
      showQuickReplyPopover: false,
      matchedQuickReplies: [],
      searchTimer: null,
      selectedQuickReplyId: null,
      selectedQuickReplyIndex: -1,
      quickReplyPage: 1,
      quickReplyPageSize: 10,
      quickReplyPagesPerLoad: 1,
      quickReplyHasMore: true,
      quickReplyLoadingMore: false,
      quickReplyLastKeyword: "",
      suggestPage: 1,
      suggestPageSize: 10,
      suggestHasMore: true,
      suggestLoadingMore: false,
      suggestKeyword: "",
      suggestResults: [],
      suggestCb: null,
      suggestScrollBound: false,
      medicalVisible: false,
      medicalLoading: false,
      medicalOptions: [
        { label: '正常', value: 'NORMAL' },
        { label: '异常', value: 'ABNORMAL' },
        { label: '未知', value: 'UNKOWN' }
      ],
      medicalForm: {
        userName: "",
        userSex: "",
        userAge: "",
        phone: "",
        idNo: "",
        registerNo: "",
        allergicHistory: "",
        presentIllness: "",
        diseaseHistory: "",
        allergyName: "",
        operHistory: "",
        marryHistory: "",
        familyHistory: "",
        liverFunction: "",
        renalFunction: "",
        treatmentSuggestion: "",
        orderNumber: "",
        prescriptionDiseInfoQOList: [],
      },
      medicalRules: {
        registerNo: [{ required: true, message: '挂号单号不能为空', trigger: 'blur' }],
        allergicHistory: [{ required: true, message: '主诉不能为空', trigger: 'blur' }],
        presentIllness: [{ required: true, message: '现病史不能为空', trigger: 'blur' }],
        diseaseHistory: [{ required: true, message: '既往史不能为空', trigger: 'blur' }],
        allergyName: [{ required: true, message: '过敏史不能为空', trigger: 'blur' }],
        operHistory: [{ required: true, message: '手术史不能为空', trigger: 'blur' }],
        marryHistory: [{ required: true, message: '婚育史不能为空', trigger: 'blur' }],
        familyHistory: [{ required: true, message: '家族史不能为空', trigger: 'blur' }],
        liverFunction: [{ required: true, message: '肝功能不能为空', trigger: 'blur' }],
        renalFunction: [{ required: true, message: '肾功能不能为空', trigger: 'blur' }],
        treatmentSuggestion: [{ required: true, message: '诊疗意见不能为空', trigger: 'blur' }],
      }
    };
  },
  methods: {
    queryQuickReplies(queryString, cb) {
      this.quickReplyLoading = true;
      this.quickReplySearchKeyword = queryString || "";
      this.suggestKeyword = this.quickReplySearchKeyword;
      this.suggestPage = 1;
      this.suggestHasMore = true;
      this.suggestResults = [];
      this.suggestCb = cb;
      this.suggestScrollBound = false;
      // 首次加载第一页
      this.fetchSuggestNextPage();
    },

    async fetchSuggestNextPage() {
      if (!this.suggestHasMore || this.suggestLoadingMore) return;
      this.suggestLoadingMore = true;
      const params = {
        cp: this.suggestPage,
        lz: this.suggestPageSize,
        pharmacyId: "",
        status: "",
        type: "",
        answerType: "",
        hospitalCode: "",
        doctorId: "",
        keyWords: this.suggestKeyword
      };
      try {
        const response = await getQuickReplyTemplates(params);
        if (response.code === 0 && response.data && Array.isArray(response.data.data)) {
          const batch = response.data.data.map(item => ({
            value: item.type === 2 ? item.answer : item.title,
            title: item.title,
            answer: item.answer,
            type: item.type,
            id: item.id
          }));
          this.suggestResults = this.suggestResults.concat(batch);
          if (this.suggestCb) this.suggestCb(this.suggestResults);
          // cp 自增
          this.suggestPage += 1;
          if (batch.length < this.suggestPageSize) this.suggestHasMore = false;
          this.$nextTick(() => {
            // 绑定下拉面板滚动事件（只绑定一次）
            const pop = document.querySelector('.el-autocomplete-suggestion__wrap');
            if (pop && !this.suggestScrollBound) {
              pop.addEventListener('scroll', this.onSuggestScroll, { passive: true });
              this.suggestScrollBound = true;
            }
          });
        } else {
          this.suggestHasMore = false;
          if (this.suggestCb) this.suggestCb(this.suggestResults);
        }
      } catch (e) {
        this.suggestHasMore = false;
        if (this.suggestCb) this.suggestCb(this.suggestResults);
      } finally {
        this.quickReplyLoading = false;
        this.suggestLoadingMore = false;
      }
    },

    onSuggestScroll(e) {
      const el = e.target;
      if (!el) return;
      const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 10;
      if (nearBottom && this.suggestHasMore && !this.suggestLoadingMore) {
        this.fetchSuggestNextPage();
      }
    },

    onMainInputChange(event) {
      const inputValue = event.target ? event.target.value : this.input;
      console.log('主输入框监听触发，输入值:', inputValue);
      this.autoResize();
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }

      const searchValue = String(inputValue || '');

      if (!searchValue || searchValue.trim() === '') {
        this.hideQuickReplyPopover();
        console.log('输入为空，隐藏popover');
        return;
      }

      // 防抖：延迟300ms后调用接口
      this.searchTimer = setTimeout(() => {
        console.log('防抖后调用后端接口进行模糊匹配，输入值:', searchValue);
        this.searchQuickRepliesFromAPI(searchValue);
      }, 300);
    },

    autoResize() {
      this.$nextTick(() => { });
    },

    resetQuickReplyPagination(keyword) {
      this.quickReplyLastKeyword = keyword;
      this.quickReplyPage = 1;
      this.quickReplyHasMore = true;
      this.matchedQuickReplies = [];
      this.selectedQuickReplyIndex = -1;
      this.selectedQuickReplyId = null;
    },

    async fetchQuickRepliesPage(page, keyword) {
      const params = {
        cp: page,
        lz: this.quickReplyPageSize,
        pharmacyId: "",
        status: "",
        type: "",
        answerType: "",
        hospitalCode: "",
        doctorId: "",
        keyWords: keyword
      };
      const res = await getQuickReplyTemplates(params);
      if (res.code === 0 && res.data && Array.isArray(res.data.data)) {
        return res.data.data;
      }
      return [];
    },

    async loadQuickRepliesPages(pages = this.quickReplyPagesPerLoad) {
      if (!this.quickReplyHasMore || this.quickReplyLoadingMore) return;
      this.quickReplyLoadingMore = true;
      const keyword = this.quickReplyLastKeyword;
      const tasks = [];
      for (let i = 0; i < pages; i++) {
        tasks.push(this.fetchQuickRepliesPage(this.quickReplyPage + i, keyword));
      }
      try {
        const pagesResult = await Promise.all(tasks);
        const flat = pagesResult.flat();
        if (flat.length > 0) {
          this.matchedQuickReplies = this.matchedQuickReplies.concat(flat);
          this.quickReplyPage += pages;
          if (flat.length < pages * this.quickReplyPageSize) {
            this.quickReplyHasMore = false;
          }
          this.showQuickReplyPopover = true;
          if (this.selectedQuickReplyIndex < 0 && this.matchedQuickReplies.length > 0) {
            this.selectedQuickReplyIndex = 0;
            this.selectedQuickReplyId = this.matchedQuickReplies[0].id;
          }
        } else {
          this.quickReplyHasMore = false;
        }
      } catch (e) {
        console.error('批量加载快捷语失败:', e);
      } finally {
        this.quickReplyLoadingMore = false;
        this.$nextTick(() => {
          // 绑定滚动事件
          const list = this.$refs.quickReplyListRef;
          if (list && list.addEventListener && !list._scrollBinded) {
            list.addEventListener('scroll', this.onQuickReplyListScroll, { passive: true });
            list._scrollBinded = true;
          }
        });
      }
    },

    onQuickReplyListScroll(e) {
      const el = e.target;
      if (!el) return;
      const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 20;
      if (nearBottom && !this.quickReplyLoadingMore && this.quickReplyHasMore) {
        this.loadQuickRepliesPages();
      }
    },

    async searchQuickRepliesFromAPI(inputValue) {
      console.log('调用后端接口进行模糊匹配，输入值:', inputValue);

      const searchValue = String(inputValue || '');

      this.$nextTick(() => {
        if (this.$refs.quickReplyPopover && this.$refs.mainTextarea) {
          this.$refs.quickReplyPopover.referenceElm = this.$refs.mainTextarea.$el;
        }
      });

      if (!this.showQuickReplyPopover && this.selectedQuickReplyIndex === -1 && this.matchedQuickReplies.length === 0 && this.quickReplyLastKeyword === searchValue) {
        return;
      }

      this.resetQuickReplyPagination(searchValue);
      await this.loadQuickRepliesPages();
    },

    searchMatchedQuickReplies(inputValue) {
      console.log('开始搜索匹配项，输入值:', inputValue);
      console.log('快捷语数据总数:', this.quickReplyOptions.length);

      const searchValue = String(inputValue || '');
      const lowerInput = searchValue.toLowerCase();

      const matched = this.quickReplyOptions.filter(item => {
        const titleMatch = String(item.title || '').toLowerCase().includes(lowerInput);
        const answerMatch = item.type === 2 && String(item.answer || '').toLowerCase().includes(lowerInput);
        return titleMatch || answerMatch;
      });
      if (matched.length > 0) {
        this.matchedQuickReplies = matched.slice(0, 20);
        this.showQuickReplyPopover = true;
        console.log('显示popover，匹配项:', this.matchedQuickReplies);
      } else {
        this.matchedQuickReplies = [];
        this.showQuickReplyPopover = false;
      }
    },
    handleQuickReplySelect(item) {
      if (item) {
        const displayText = item.type === 2 ? item.answer : item.title;
        this.input = displayText;
        this.quickReplyInput = "";
        this.$nextTick(() => {
          const textarea = this.$refs.mainTextarea;
          if (textarea && textarea.focus) {
            textarea.focus();
          }
        });
      }
    },

    handleQuickReplyClick(item, index) {
      this.selectedQuickReplyIndex = index;
      this.selectedQuickReplyId = item.id;
      const displayText = item.type === 2 ? item.answer : item.title;
      this.input = displayText;
      this.hideQuickReplyPopover();
      this.$nextTick(() => {
        const textarea = this.$refs.mainTextarea;
        if (textarea && textarea.focus) {
          textarea.focus();
        }
      });
      console.log('单击快捷语，已回填到输入框:', displayText);
    },

    clearSelection() {
      this.selectedQuickReplyIndex = -1;
      this.selectedQuickReplyId = null;
    },

    handleQuickReplyDoubleClick(item) {
      const displayText = item.type === 2 ? item.answer : item.title;
      this.input = displayText;
      this.showQuickReplyPopover = false;
      this.matchedQuickReplies = [];
      this.selectedQuickReplyId = null;
      this.selectedQuickReplyIndex = -1;

      const lineCount = displayText.split('\n').length;
      const charCount = displayText.length;
      console.log('回填数据信息:', {
        text: displayText.substring(0, 100) + (displayText.length > 100 ? '...' : ''),
        lineCount: lineCount,
        charCount: charCount
      });

      console.log('双击快捷语已回填到输入框:', displayText);
    },
    selectQuickReply(item) {
      if (item) {
        const displayText = item.type === 2 ? item.answer : item.title;
        this.input = displayText;
        this.hideQuickReplyPopover();
        this.$nextTick(() => {
          const textarea = this.$refs.mainTextarea;
          if (textarea && textarea.focus) {
            textarea.focus();
          }
        });
        console.log('快捷语已回填到输入框:', displayText);
      }
    },
    onQuickReplyFocus() {
      this.queryQuickReplies("", (results) => {
      });
    },
    handleEnterKey(event) {
      console.log('handleEnterKey被调用', {
        showQuickReplyPopover: this.showQuickReplyPopover,
        matchedQuickRepliesLength: this.matchedQuickReplies.length,
        eventType: event.type,
        target: event.target
      });
      if (this.showQuickReplyPopover && this.matchedQuickReplies.length > 0) {
        console.log('popover打开，阻止发送消息');
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
      console.log('popover关闭，正常发送消息');
      this.send();
    },
    handleKeydown(event) {
      if (event.key === 'q' && event.ctrlKey) {
        event.preventDefault(); // 阻止默认行为
        const autocompleteElement = this.$el.querySelector('.quick-reply-container .el-autocomplete');
        if (autocompleteElement) {
          autocompleteElement.focus();
        }
      }

      // 处理快捷语popover的键盘导航
      if (this.showQuickReplyPopover && this.matchedQuickReplies.length > 0) {
        console.log('全局键盘事件处理popover', {
          key: event.key,
          showQuickReplyPopover: this.showQuickReplyPopover,
          matchedQuickRepliesLength: this.matchedQuickReplies.length
        });

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          event.stopPropagation();
          this.selectedQuickReplyIndex = Math.min(this.selectedQuickReplyIndex + 1, this.matchedQuickReplies.length - 1);
          this.selectedQuickReplyId = this.matchedQuickReplies[this.selectedQuickReplyIndex].id;
          console.log('向下选择，当前索引:', this.selectedQuickReplyIndex);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          event.stopPropagation();
          this.selectedQuickReplyIndex = Math.max(this.selectedQuickReplyIndex - 1, 0);
          this.selectedQuickReplyId = this.matchedQuickReplies[this.selectedQuickReplyIndex].id;
          console.log('向上选择，当前索引:', this.selectedQuickReplyIndex);
        } else if (event.key === 'Enter') {
          event.preventDefault();
          event.stopPropagation();
          if (this.selectedQuickReplyIndex >= 0 && this.selectedQuickReplyIndex < this.matchedQuickReplies.length) {
            const selectedItem = this.matchedQuickReplies[this.selectedQuickReplyIndex];
            // 回填选中的快捷语到输入框（不自动发送）
            const displayText = selectedItem.type === 2 ? selectedItem.answer : selectedItem.title;
            this.input = displayText;
            this.showQuickReplyPopover = false;
            this.matchedQuickReplies = [];
            this.selectedQuickReplyId = null;
            this.selectedQuickReplyIndex = -1;
            // 聚焦回主输入框
            this.$nextTick(() => {
              const textarea = this.$refs.mainTextarea;
              if (textarea && textarea.focus) {
                textarea.focus();
              }
            });
          }
        } else if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          this.showQuickReplyPopover = false;
          this.matchedQuickReplies = [];
          this.selectedQuickReplyId = null;
          this.selectedQuickReplyIndex = -1;
        }
      }
    },

    send() {
      var time = new Date();
      if ((store.state.showMsgFlag && store.state.StatusFlag) || localStorage.getItem('chatDebug') === '1') {
        let data = {
          contentType: 0,
          doctorCode: "", //发送者id
          data: "",
          orderNumber: "", //发送时间
          type: 0, //消息内容
        };
        data.data = this.input;
        if (data.data != "") {
          //   /* 自己的信息直接push到数组中 */
          data.orderNumber = store.state.orderNumber;
          let useObj = JSON.parse(JSON.stringify(data));
          data.doctorCode = localStorage.getItem("doctorEmployee");
          useObj.doctorCode = data.doctorCode;
          useObj.sendType = 2;
          useObj.contentData = data.data;
          const isDebug = localStorage.getItem('chatDebug') === '1';
          if (isDebug) {
            // 调试模式：不调接口，直接本地渲染
            if (!data.orderNumber) {
              data.orderNumber = 'DEBUG_' + Date.now();
              useObj.orderNumber = data.orderNumber;
            }
            store.commit("SOCKET_updateChatMessageList", useObj);
            this.scrollChatToBottom();
          } else {
            msgUp(data).then((query) => {
              if (query.code == 0) {
                // store.commit("SET_COUNT", 0);
                store.commit("SOCKET_updateChatMessageList", useObj);
              } else {
                this.tipsFlag = true;
                this.tipsMsg = query.msg;
                setTimeout(() => {
                  this.tipsFlag = false;
                }, 2000);
              }
            });
            this.scrollChatToBottom();
          }
        }
      } else {
        this.tipsFlag = true;
        this.tipsMsg = "请对该患者预约接诊后发送消息";
        setTimeout(() => {
          this.tipsFlag = false;
        }, 2000);
      }

      // }
      /* 清空输入框 */
      this.input = "";
    },
    sendImg(file) {
      const isJPG = file.type === "image/png" || file.type === "image/jpeg";
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG与PNG 格式!");
        return false;
      } else if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 3MB!");
        return false;
      } else {
        let postData = {
          file: "",
        };
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          postData.file = reader.result;
          imgUpload(postData)
            .then((data) => {
              if (data.code == 0) {
                let postImgData = {
                  contentType: 1,
                  data: data.data,
                  doctorCode: localStorage.getItem("doctorEmployee"),
                  orderNumber: store.state.orderNumber,
                  type: 0,
                };
                msgUp(postImgData).then((res) => {
                  if (res.code == 0) {
                    let send_Img = {
                      base64: reader.result,
                      sendDate: new Date(),
                    };
                    store.commit("SET_SENDIMG", send_Img);
                  } else {
                    this.loading2 = false;
                    this.outFlag2 = true;
                    this.errorMsg = res.msg;
                    setTimeout(() => {
                      this.outFlag2 = false;
                    }, 2000);
                  }
                });
              } else {
                this.outFlag2 = true;
                this.errorMsg = "请重新上传图片";
                setTimeout(() => {
                  this.outFlag = false;
                }, 2000);
              }
            })
            .catch(() => {
              this.outFlag2 = true;
              this.errorMsg = "请重新上传图片";
              setTimeout(() => {
                this.outFlag = false;
              }, 2000);
            });
        };
        return false;
      }
    },
    scrollChatToBottom() {
      // 将聊天框定位到底部
      this.$nextTick(() => {
        const chatContainer =
          this.$parent.$parent.$children[0].$refs.boxContent;
        this.$parent.$parent.$children[0].$el.scrollTop =
          this.$parent.$parent.$children[0].$el.scrollHeight;
      });
    },
    sendFlag() {
      if (store.state.StatusFlag == false) {
        this.tipsFlag = true;
        this.tipsMsg = "请在接诊后再尝试开处方";
        setTimeout(() => {
          this.tipsFlag = false;
        }, 2000);
      } else {
        const loading = this.$loading({
          lock: true,
          text: '请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)',
          customClass: 'green-loading'
        });

        setTimeout(() => {
          this.CF_Flag = true;
          store.commit("SET_CF_FLAG", this.CF_Flag);
          loading.close();
        }, 300);
      }
    },
    // 强制打开下拉框
    openQuickReplyDropdown() {
      this.$nextTick(() => {
        if (this.$refs.quickReplySelect) {
          // 模拟点击下拉框来打开它
          const selectElement = this.$refs.quickReplySelect.$el;
          if (selectElement) {
            selectElement.click();
          }
        }
      });
    },
    hideQuickReplyPopover() {
      this.showQuickReplyPopover = false;
      this.matchedQuickReplies = [];
      this.selectedQuickReplyId = null;
      this.selectedQuickReplyIndex = -1;
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
    },
    isInside(el, target) {
      if (!el || !target) return false;
      try {
        return el === target || el.contains(target);
      } catch (e) {
        return false;
      }
    },
    async getWesternDiagOptions(params) {
      const postData = {
        cp: params.page.toString(),
        lz: params.pageSize.toString(),
        dictType: "diag_type",
        keyword: params.keyword,
        type: '1'
      };
      return await dictDataList(postData);
    },
    async getTcmDiagOptions(params) {
      const postData = {
        cp: params.page.toString(),
        lz: params.pageSize.toString(),
        dictType: "diag_type",
        keyword: params.keyword,
        type: '2'
      };
      return await dictDataList(postData);
    },
    async getTcmDiagnosisOptions(params) {
      return await dictDataList({
        cp: params.page.toString(),
        lz: params.pageSize.toString(),
        dictType: "diag_type",
        keyword: params.keyword,
        type: '3' // 中医诊断
      });
    },

    async getWesternDiagnosisOptions(params) {
      return await dictDataList({
        cp: params.page.toString(),
        lz: params.pageSize.toString(),
        dictType: "diag_type",
        keyword: params.keyword,
        type: '1' // 西医诊断
      });
    },

    async getTcmSyndromeOptions(params) {
      return await dictDataList({
        cp: params.page.toString(),
        lz: params.pageSize.toString(),
        dictType: "diag_type",
        keyword: params.keyword,
        type: '4' // 中医证候
      });
    },
    onMedicalDiagBlur(row) {
      setTimeout(() => {
        if (row.diagName !== row.lastValidName) {
          row.diagName = '';
          row.diagCode = '';
          row.lastValidName = '';
        }
      }, 200);
    },
    onMedicalDiagSelect(item, row) {
      row.diagName = item.diagnosisName || item.value;
      row.diagCode = item.diagnosisCode || item.code;
      row.lastValidName = row.diagName;
    },
    onMedicalSyndromeSelect(item, row) {
      row.sympName = item.diagnosisName || item.value;
      row.sympCode = item.diagnosisCode || item.code;
      row.lastValidSympName = row.sympName;
    },
    onMedicalSyndromeBlur(row) {
      setTimeout(() => {
        if (row.sympName !== row.lastValidSympName) {
          row.sympName = '';
          row.sympCode = '';
          row.lastValidSympName = '';
        }
      }, 200);
    },
    onMedicalDiagTypeChange(row) {
      row.diagName = "";
      row.diagCode = "";
      row.sympName = "";
      row.sympCode = "";
    },
    searchMedicalDiagAutocomplete(query, callback, row) {
      dictDataList({
        cp: "1",
        lz: "50",
        dictType: "diag_type",
        keyword: query,
        type: row.diagType
      }).then(res => {
        if (res.code === 0) {
          const suggestions = res.data.data.map(i => ({ value: i.diagnosisName, code: i.diagnosisCode }));
          callback(suggestions);
        } else {
          callback([]);
        }
      });
    },
    addMedicalDiagnosis() {
      this.medicalForm.prescriptionDiseInfoQOList.push({
        diagCode: "",
        diagName: "",
        lastValidName: "",
        diagSrtNo: this.medicalForm.prescriptionDiseInfoQOList.length + 1,
        diagType: this.isTraditionalChineseMedicine ? "3" : "1",
        mainDiagFlag: "1",
        sympCode: "",
        sympName: "",
        lastValidSympName: ""
      });
    },
    removeMedicalDiagnosis(index) {
      this.medicalForm.prescriptionDiseInfoQOList.splice(index, 1);
      this.medicalForm.prescriptionDiseInfoQOList.forEach((item, idx) => {
        item.diagSrtNo = idx + 1;
      });
    },
    queryMedicalDiagnosis(queryString, cb, row) {
      if (!queryString) {
        cb([]);
        return;
      }
      const params = {
        cp: "1",
        lz: "20",
        dictType: "diag_type",
        keyword: queryString,
        type: row.diagType
      };
      dictDataList(params).then(res => {
        if (res.code === 0 && res.data.data) {
          const results = res.data.data.map(item => ({
            value: item.diagnosisName,
            code: item.diagnosisCode
          }));
          cb(results);
        } else {
          cb([]);
        }
      }).catch(() => cb([]));
    },
    handleMedicalDiagSelect(item, row) {
      row.diagCode = item.code;
      row.diagName = item.value;
    },

    handleGlobalClick(event) {
      if (!this.showQuickReplyPopover) return;
      const target = event.target;
      const popComp = this.$refs.quickReplyPopover;
      const popEl = popComp && (popComp.popperElm || popComp.$el) ? (popComp.popperElm || popComp.$el) : null;
      const inputEl = this.$refs.mainTextarea && this.$refs.mainTextarea.$el ? this.$refs.mainTextarea.$el : null;

      const inside = this.isInside(popEl, target) || this.isInside(inputEl, target);
      if (!inside) {
        this.hideQuickReplyPopover();
      }
    },
    async syncDiagnosisFromStore() {
      const recordData = this.$store.state.recordData;
      if (!recordData || !recordData.illName || !recordData.illName.trim()) {
        this.$set(this.medicalForm, 'prescriptionDiseInfoQOList', []);
        return;
      }

      const isTCM = this.isTraditionalChineseMedicine;

      try {
        const diagRes = await sicknessList({
          diagnosisNames: recordData.illName,
          type: isTCM ? "3" : "1"
        });

        if (diagRes.code === 0 && diagRes.data) {
          let fetchedSympCode = "";
          let fetchedSympName = recordData.illDesc || "";

          if (isTCM && fetchedSympName) {
            const sympRes = await dictDataList({
              cp: "1",
              lz: "8",
              dictType: "diag_type",
              keyword: fetchedSympName,
              type: "4"
            });
            if (sympRes.code === 0 && sympRes.data.data && sympRes.data.data.length > 0) {
              fetchedSympCode = sympRes.data.data[0].diagnosisCode;
              fetchedSympName = sympRes.data.data[0].diagnosisName;
            }
          } else if (!isTCM) {
            fetchedSympCode = "";
            fetchedSympName = this.medicalForm.allergicHistory || recordData.illDesc || "";
          }

          const formattedList = diagRes.data.map((item, index) => ({
            diagCode: item.diagnosisCode,
            diagName: item.diagnosisName,
            lastValidName: item.diagnosisName,
            diagSrtNo: index + 1,
            diagType: isTCM ? "2" : "1",
            mainDiagFlag: index === 0 ? "1" : "1",
            sympCode: fetchedSympCode,
            sympName: fetchedSympName,
            lastValidSympName: fetchedSympName
          }));

          this.$set(this.medicalForm, 'prescriptionDiseInfoQOList', formattedList);
        }
      } catch (error) {
        console.error("同步诊断数据失败:", error);
      }
    },
    handleMedicalRecord() {
      if (!store.state.StatusFlag) {
        this.$message.warning("请在接诊后再进行操作");
        return;
      }
      const orderNumber = store.state.orderNumber;

      getMedicalRecordPre({ orderNumber })
        .then(async (res) => {
          if (res.code === 0) {
            const remoteData = res.data;
            if (this.$refs.medicalForm) {
              this.$refs.medicalForm.resetFields();
            }

            Object.keys(this.medicalForm).forEach((key) => {
              if (remoteData.hasOwnProperty(key)) {
                this.medicalForm[key] = remoteData[key];
              }
            });
            this.medicalForm.orderNumber = orderNumber;

            const isTCM = this.isTraditionalChineseMedicine;

            if (remoteData.diagName && remoteData.diagName.trim()) {
              const names = remoteData.diagName.split('|');
              const codes = (remoteData.diagCode || "").split('|');
              const sympNames = (remoteData.sympName || "").split('|');
              const sympCodes = (remoteData.sympCode || "").split('|');

              const list = names.map((name, index) => {
                return {
                  diagName: name,
                  lastValidName: name,
                  diagCode: codes[index] || "",
                  sympName: sympNames[index] || "",
                  lastValidSympName: sympNames[index] || "",
                  sympCode: sympCodes[index] || "",
                  diagSrtNo: index + 1,
                  diagType: isTCM ? "3" : "1",
                  mainDiagFlag: index == 0 ? "1" : "1"
                };
              });
              this.$set(this.medicalForm, 'prescriptionDiseInfoQOList', list);
            } else {
              await this.syncDiagnosisFromStore();
            }

            this.medicalVisible = true;
            this.$nextTick(() => {
              if (this.$refs.medicalForm) {
                this.$refs.medicalForm.clearValidate();
              }
            });
          } else {
            this.$message.error(res.msg || "获取病历信息失败");
          }
        })
        .catch((err) => {
          console.error("获取病历预览异常:", err);
          this.$message.error("获取病历预览异常");
        })
        .finally(() => {
        });
    },
    initDiagnosisFromStore() {
      const recordData = store.state.recordData;
      if (recordData && recordData.illName && recordData.illName.trim()) {
        sicknessList({
          diagnosisNames: recordData.illName,
          type: this.isTraditionalChineseMedicine ? "3" : "1"
        }).then(diagRes => {
          if (diagRes.code === 0 && diagRes.data) {
            const list = diagRes.data.map((item, index) => ({
              diagCode: item.diagnosisCode,
              diagName: item.diagnosisName,
              diagSrtNo: index + 1,
              diagType: this.isTraditionalChineseMedicine ? "3" : "1",
              mainDiagFlag: index === 0 ? "1" : "0",
              sympCode: "", // 西药要求为空
              sympName: this.medicalForm.allergicHistory || recordData.illDesc || "" // 读取主诉
            }));
            this.$set(this.medicalForm, 'prescriptionDiseInfoQOList', list);
          }
        });
      }
    },
    submitMedicalRecord() {
      this.$refs.medicalForm.validate((valid) => {
        if (valid) {
          this.medicalLoading = true;
          saveMedicalRecord(this.medicalForm).then(res => {
            if (res.code == 0) {
              this.$message.success("保存病历成功！");
              this.medicalVisible = false;
            } else {
              this.$message.error(res.msg);
            }
          }).finally(() => {
            this.medicalLoading = false;
          });
        }
      });
    }

  },
  mounted() {
    this.scrollChatToBottom();
    // 添加快捷键监听，使用capture确保优先级
    document.addEventListener('keydown', this.handleKeydown, true);
    // 添加窗口大小变化监听
    window.addEventListener('resize', this.handleWindowResize);
    // 初始化textarea高度
    this.$nextTick(() => {
      this.autoResize();
    });

    // 设置popover的参考元素为文本域
    this.$nextTick(() => {
      if (this.$refs.quickReplyPopover && this.$refs.mainTextarea) {
        // 设置参考元素为文本域，这样popover会相对于文本域定位
        this.$refs.quickReplyPopover.referenceElm = this.$refs.mainTextarea.$el;
        console.log('Popover参考元素已设置为文本域');
      }
    });

    // 添加全局点击监听，点击区域外关闭主输入框的快捷语下拉
    document.addEventListener('mousedown', this.handleGlobalClick, true);
    document.addEventListener('click', this.handleGlobalClick, true);
  },

  beforeDestroy() {
    // 移除快捷键监听
    document.removeEventListener('keydown', this.handleKeydown, true);
    // 移除窗口大小变化监听
    window.removeEventListener('resize', this.handleWindowResize);
    // 清理定时器
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }

    // 移除全局点击监听
    document.removeEventListener('mousedown', this.handleGlobalClick, true);
    document.removeEventListener('click', this.handleGlobalClick, true);
  },
  watch: {
    '$store.state.recordData': {
      deep: true,
      handler(newData) {
        if (newData) {
          console.log('检测到 store 中诊断信息变化，同步至病历表单');
          this.syncDiagnosisFromStore();
        }
      }
    },
    ImgData() {
      let postImgData = {
        contentType: 1,
        data: this.storeImgData.cover,
        doctorCode: localStorage.getItem("doctorEmployee"),
        orderNumber: store.state.orderNumber,
        type: 0,
      };
      msgUp(postImgData).then((res) => {
        if (res.code == 0) {
          let send_Img = {
            base64: this.storeImgData.getImg,
            sendDate: new Date(),
          };
          store.commit("SET_SENDIMG", send_Img);
        } else {
          this.loading2 = false;
          this.outFlag2 = true;
          this.errorMsg = res.msg;
          setTimeout(() => {
            this.outFlag2 = false;
          }, 2000);
        }
      });
    },
    // 监听popover显示状态变化
    showQuickReplyPopover(newVal) {
      if (newVal) {
        // Element UI 会自动处理 popover 位置
        console.log('Popover 已显示');
      } else {
        console.log('Popover 已隐藏');
      }
    },
  },
  computed: {
    myInfo() {
      return store.state.myInfo;
    },
    chatType() {
      return store.state.chatType;
    },
    userInfo() {
      return store.state.userInfo;
    },
    ImgData() {
      let ImgData = {
        getImg: store.state.getImg,
        cover: store.state.cover,
      };
      this.storeImgData = ImgData;
      return ImgData;
    },
    stateFlag() {
      return store.state.StatusFlag;
    },
    isTraditionalChineseMedicine() {
      const kind = this.$store.state.recordData && this.$store.state.recordData.prescrKind;
      return String(kind) == 2;
    }
  },
};
</script>

<style scoped>
.inputBox {
  position: relative;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: visible;
}

.flexBox {
  display: flex;
  align-items: center;
  padding: 10px 0 0 0;
  position: relative;
  min-height: 40px;
}

.input-row {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  margin-top: 25px;
  padding-left: 15px;
  min-height: 200px;
  padding-right: 190px;
}

.input-row .el-textarea {
  flex: 1;
}

.el-textarea /deep/ .el-textarea__inner {
  border: none !important;
}

.input-row .sendButton {
  position: fixed !important;
  right: 24px !important;
  bottom: 24px !important;
  z-index: 3000;
  height: 40px;
  padding: 0 24px;
  font-size: 15px;
  font-weight: 500;
}

.hoverIcon {
  font-size: 26px;
  color: #0caf60;
}

.hoverIcon:hover {
  color: #0caf60;
  cursor: pointer;
}

.tipsMsgBox /deep/ .el-dialog__header {
  display: none;
  background: rgb(16, 17, 17);
}

.tipsMsgBox /deep/ .el-dialog__body {
  background: #fff;
  color: #0caf60;
  text-align: center;
}

.tipsMsgBox .el-dialog__body {
  background: #fff;
  color: #0caf60;
  text-align: center;
}

.iconButton {
  font-size: 28px !important;
  color: #0caf60;
  margin: 0 !important;
  display: block;
}

.imgIcon {
  width: 28px;
  height: 28px;
  object-fit: contain;
  display: block;
  margin: 0 !important;
}

.icon-wrapper /deep/ .el-upload {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}


.iconButton:hover {
  color: #0caf60;
}

/* 快捷语样式 */
.flexBox {
  position: relative;
}

.quick-reply-container {
  position: absolute;
  top: 36%;
  transform: translateY(-50%);
  right: 24px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  z-index: 2;
}


.quick-reply-container /deep/ .el-autocomplete {
  width: 420px;
}

.quick-reply-container /deep/ .el-input__inner {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  height: 38px;
  line-height: 38px;
  padding-left: 12px;
  border: 1px solid #90e0b6;
  box-shadow: none;
  transition: all .2s ease;
}

.quick-reply-tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  margin-right: 8px;
  white-space: nowrap;
  flex-shrink: 0;
  min-width: 60px;
  justify-content: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
  line-height: 20px;
}

.quick-reply-tag i {
  margin-right: 3px;
  font-size: 10px;
  color: inherit;
}

/* 悬浮状态下的图标样式 */
.quick-reply-item:hover .quick-reply-tag i {
  color: inherit !important;
}

.quick-reply-item.selected .quick-reply-tag i {
  color: inherit !important;
}

.quick-tag {
  background-color: #f0f9ff;
  border: 1px solid #67c23a;
  color: #67c23a;
}

.qa-tag {
  background-color: #fdf6ec;
  border: 1px solid #e6a23c;
  color: #e6a23c;
}

/* 悬浮状态下的标签样式 */
.quick-reply-item:hover .quick-reply-tag {}

.quick-reply-item.selected .quick-reply-tag {}

/* 建议项样式 */
.suggestion-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 4px 0;
}

.suggestion-title {
  text-align: left;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  cursor: pointer;
  flex: 1;
}

.popover-reference {
  position: absolute;
  bottom: -200px;
  left: 0;
  width: 100%;
  height: 1px;
  pointer-events: none;
}

.quick-reply-list {
  max-height: 300px;
  overflow-y: auto;
  min-width: 400px;
  scrollbar-color: #c0c4cc #f5f7fa;
}

.quick-reply-list::-webkit-scrollbar {
  width: 6px;
}

.quick-reply-list::-webkit-scrollbar-track {
  background: #f5f7fa;
  border-radius: 3px;
}

.quick-reply-list::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 3px;
}

.quick-reply-list::-webkit-scrollbar-thumb:hover {
  background: #909399;
}

.quick-reply-item {
  padding: 8px 12px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s;
  position: relative;
  min-height: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 20px;
}

.quick-reply-item:hover {
  background-color: #d7e1ef;
  color: #fff;
  z-index: 10;
}

.quick-reply-item.selected {
  background-color: #d7e1ef;
  color: #fff;
}

.quick-reply-item.selected .item-text {
  color: #333;
}

.quick-reply-item:hover {
  background-color: #d7e1ef !important;
  color: #333 !important;
}

.quick-reply-item:hover .item-text {
  color: #333 !important;
}

.quick-reply-item:last-child {
  border-bottom: none;
}

.item-text {
  font-size: 14px;
  color: #303133;
  line-height: 20px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-wrap: break-word;
  max-width: 100%;
  cursor: pointer;
  flex: 1;
}

.quick-reply-item:hover .item-text {
  color: #fff;
}

.quick-reply-container /deep/ .el-input__inner {
  border-radius: 20px;
}

.quick-reply-container /deep/ .el-select:hover .el-input__inner,
.quick-reply-container /deep/ .el-input.is-focus .el-input__inner,
.quick-reply-container /deep/ .el-input__inner:focus {
  border-color: #0caf60 !important;
  box-shadow: 0 6px 14px rgba(12, 175, 96, 0.18);
}

.quick-reply-container /deep/ .el-select-dropdown__item {
  padding: 0 20px;
  line-height: 34px;
}

.quick-reply-container /deep/ .el-select-dropdown__item:hover {
  background-color: #42b6ff;
  color: #fff;
}

.quick-reply-container /deep/ .el-select-dropdown__item.selected {
  color: #42b6ff;
  font-weight: bold;
}

/* 高亮匹配的文本 */
.quick-reply-container /deep/ .el-select-dropdown__item.highlighted {
  background-color: #42b6ff;
  color: #fff;
}

/* 匹配文本高亮 */
.quick-reply-container /deep/ .el-select-dropdown__item .highlight {
  background-color: #ffd700;
  color: #333;
  font-weight: bold;
}

::v-deep .el-popover.main-input-popover {
  padding: 5px;
  font-size: 12px;
  color: #333;
  background-color: #fff;
  z-index: 9999;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transform: translate3d(0px, 120px, 0px) !important;
}

.inputBox .main-input-popover {
  position: absolute !important;
}

.medical-form .el-form-item {
  margin-bottom: 18px;
}

.medical-form .el-textarea__inner {
  font-family: inherit;
}

.el-dialog .el-form-item .el-input,
.el-dialog .el-form-item .el-select,
.el-dialog .el-form-item .el-textarea {
  width: 100%;
}

::v-deep .el-textarea__inner {
  font-family: inherit;
  font-size: 14px;
}

::v-deep .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
  content: '*';
  color: #F56C6C;
  margin-right: 4px;
}

.input-row /deep/ .el-textarea__inner {
  border: none !important;
  box-shadow: none !important;
  padding-top: 2px !important;
  padding-left: 0 !important;
}

.medical-form-content /deep/ .el-textarea__inner,
.medical-form-content /deep/ .el-input__inner {
  border: 1px solid #dcdfe6 !important;
  background-color: #fff !important;
}

.medical-form-content /deep/ .el-textarea__inner:focus,
.medical-form-content /deep/ .el-input__inner:focus {
  border-color: #0caf60 !important;
}

.tool-bar-container {
  display: flex;
  align-items: flex-start;
  padding: 10px 15px 15px 15px !important;
  border-bottom: 1px solid #f5f5f5;
  background: #fff;
}

.tool-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 60px;
  margin-right: 5px;
  cursor: pointer;
}

.tool-item:hover .tool-text,
.tool-item:hover .iconButton {
  color: #0caf60;
  opacity: 0.8;
}

.icon-wrapper {
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}


.tool-text {
  font-size: 12px;
  color: #666;
  margin-top: 8px;
  white-space: nowrap;
  line-height: 1;
  text-align: center;
}
</style>